import { render, staticRenderFns } from "./AssessmentSubjects.vue?vue&type=template&id=66159c8e&"
import script from "./AssessmentSubjects.vue?vue&type=script&lang=js&"
export * from "./AssessmentSubjects.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentSubjects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports